import GlobalMediaTypes from "routes/Base/Admin/GlobalMediaTypes"
import Surface from "components/Surface"
import { css } from "@emotion/css"
import { useParams } from "react-router-dom"

export default function AgencyClientMediaTypes() {
  const { configId } = useParams<{ configId: string }>()
  return (
    <Surface className={styles.surface}>
      <GlobalMediaTypes
        configScope="CLIENT_AGENCY_CONFIG"
        configOwnerId={configId}
      />
    </Surface>
  )
}

const styles = {
  surface: css`
    padding: var(--spacing-xxl-2) 0 0;
  `,
}
